import React from 'react'
import { WhereRow, WhereQberaa, WhereQberaavideo, WhereQberaaTitle, WhereQberaaContent, WhereQberaaRedBox } from './StyledComponents'
import { whereQberaaCanHelp } from '../../../data/websiteData'
import { Grid, Col, Row } from '../../../styles/GlobalTheme/GlobalStyledComponents';
import bgVedio from '../../../assets/home/bg2.mp4'
import Fade from 'react-reveal/Fade';

const WhereQberaaCanHelp = () => {

    return (
        <Grid bgColor="#0A2540">
            <WhereRow>
                <div>
                    <Fade bottom cascade duration={1000}>
                        <WhereQberaaTitle>{whereQberaaCanHelp.title}</WhereQberaaTitle>
                        <WhereQberaaContent>{whereQberaaCanHelp.content1}</WhereQberaaContent>
                        <WhereQberaaContent>{whereQberaaCanHelp.content2}</WhereQberaaContent>
                        <WhereQberaaRedBox />
                    </Fade>                
                </div>
                <WhereQberaavideo autoPlay="autoplay" loop="loop" muted className="VideoBox2">
                    <source src={bgVedio} type="video/mp4" />
                        Your browser does not support the video tag.
                    </WhereQberaavideo>
            </WhereRow>
        </Grid>
    )
}

export default WhereQberaaCanHelp
